import { getCurrentUser } from 'aws-amplify/auth';

// Learning tools are free. Sign-in protects saved work; this does not grant a
// paid subscription or admin rights. Billing checks stay separate.
export async function checkLearningAccess() {
  try { return Boolean((await getCurrentUser()).userId); }
  catch { return false; }
}
